export default {
  comdify (n) {
    if(!n) return n;
    let str = n.split('.');
    let re = /\d{1,3}(?=(\d{3})+$)/g;
    let n1 = str[0].replace(re, "$&,");
    return str.length > 1 && str[1] ? `${n1}.${str[1]}` : `${n1}.00`;
  },
  delcommafy (num) {
    if((num + '').trim() == ''){
      return '';
      
      }
    console.log(num.replace(/,/gi,''))
    num = num.replace(/,/gi,'');
    
    return num;
  }
}


